import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="relative bg-gradient-to-b from-[#0f0c29] via-[#302b63] to-[#24243e] rounded-xl shadow-2xl max-w-4xl w-full mx-4 p-8 border border-white/20 backdrop-blur-md">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-3xl text-white font-bold hover:text-red-400 transition duration-300 bg-none border-none shadow-none"
          style={{ background: 'none', border: 'none', boxShadow: 'none', padding: 0 }}
          aria-label="Close Modal"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
